import styled from '@emotion/styled';
import { borderRadius, breakpoints, spacing } from '@naf/theme';
import { Top } from '../Styles';

export const MediaOverflow = '80px';

export const Spacer = styled.div`
  margin-bottom: ${MediaOverflow};
`;

export const StyledTop = styled(Top)`
  align-items: start;
  @media (max-width: ${breakpoints.m}) {
    width: 100%;
  }
`;

export const Bottom = styled.div<{ $breakEarly?: boolean }>`
  display: flex;
  gap: ${spacing.space80};
  justify-content: space-between;
  flex-grow: 1;
  width: 100%;

  @media (max-width: ${({ $breakEarly }) => ($breakEarly ? breakpoints.l : breakpoints.m)}) {
    flex-direction: column-reverse;
    gap: ${spacing.space40};
  }
`;

export const BenefitWrapper = styled.div`
  flex-grow: 1;
  z-index: 3;
`;

export const MediaWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  max-width: 736px;
  z-index: 10;
  border-radius: ${borderRadius.S};
  margin-bottom: -${MediaOverflow};

  img,
  video {
    border-radius: ${borderRadius.S};
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const TimerWrapper = styled.div`
  margin-bottom: ${spacing.space24};
`;

export const ButtonGroupWrapper = styled.div<{ $breakEarly?: boolean }>`
  @media (max-width: ${({ $breakEarly }) => ($breakEarly ? breakpoints.l : breakpoints.m)}) {
    margin-top: ${spacing.space80};
  }
`;
